export default __webpack_public_path__ + "assets/holiday-cards/holiday-card-wallpaper-downloads.png";